export const WbStages = [
  "Final",
  "Semi Final",
  "Cuartos de Final",
  "Octavos de Final",
  "16avos de Final",
  "32avos de Final",
  "64avos de Final",
  "128avos de Final",
  "256avos de Final",
  "512avos de Final",
  "1024avos de Final",
];
